import {FC} from 'react'
import {downloadTemplateAutomaticUser, uploadMasiveAutomaticUser} from '../../../../services'
import {FormMasiveBulk} from '../../../../../../components/UI/Form/MasiveBulk'

const MasiveAutomaticUploadUser: FC = () => {
  const handleUpload = async (formData: FormData, bulkLoadId: string): Promise<any> => {
    try {
      const response = await uploadMasiveAutomaticUser(formData, bulkLoadId)
      return response
    } catch (error) {
      console.error('Error al cargar el archivo:', error)
    }
  }

  return (
    <FormMasiveBulk
      serviceTemplate={downloadTemplateAutomaticUser}
      handleSendService={handleUpload}
      textData1='Carga masiva de Perfiles:'
      textData='Carga masiva de Usuario:'
      title='Usuario'
      fileNameDownload='usuarios-plantilla-automatica'
    />
  )
}

export {MasiveAutomaticUploadUser}
